import { render } from "./MemberSelector.vue?vue&type=template&id=04085f3f&scoped=true"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"

import "./MemberSelector.vue?vue&type=style&index=0&id=04085f3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04085f3f"]])

export default __exports__